module.exports = __webpack_public_path__ + "img/auction.b9341cc2.png";